import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { IoBarChart, IoClose } from "react-icons/io5";
import { PiPackageFill } from "react-icons/pi";
import { FaTruckMoving, FaPlaneDeparture, FaUserCircle } from "react-icons/fa";
import { TbPackages } from "react-icons/tb";
import { IoIosPeople } from "react-icons/io";
import { GrSettingsOption, GrUserWorker } from "react-icons/gr";
import { LuPackageCheck } from "react-icons/lu";
import { AiOutlineFileUnknown } from "react-icons/ai";
import { CgLogOut } from "react-icons/cg";
import { BiSolidReport } from "react-icons/bi";
import { MdMenuOpen } from "react-icons/md";
import logo from '../assets/images/mainIcon.jpeg';

export default function Sidebar({ isDrawerOpen, onDrawerToggle, className }) {
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 799);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem('user'));

  const handleDrawerToggle = () => {
    try{
      setOpen(prevOpen => !prevOpen);
      if (onDrawerToggle) {
        onDrawerToggle(!open);
      }
    }catch(error){
      console.error('Error fetching user data:', error);
    }
   
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 799;
      setIsMobile(mobile);
      setOpen(!mobile);
      if (onDrawerToggle) {
        onDrawerToggle(!mobile);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [onDrawerToggle]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Prevent rendering if user is null (during sign out process)
  if (!user) {
    return null;
  }

  const menuItems = user?.role === "Courier"
    ? [
        { text: 'Dashboard', route: '/dashboard', icon: <IoBarChart /> },
        // { text: 'Delivery Routes', route: '/delivery-routes', icon: <FaTruckMoving /> },
        { text: 'Water Deliveries', route: '/water-deliveries', icon: <PiPackageFill /> },
        { text: 'Customer Locations', route: '/customer-locations', icon: <IoIosPeople /> },
        { text: 'Delivery Notifications', route: '/notifications', icon: <AiOutlineFileUnknown /> },
        { text: 'Claims & Issues', route: '/claims', icon: <LuPackageCheck /> },
        { text: 'Signout', action: handleLogout, icon: <CgLogOut /> },
      ]
    : [
        { text: 'Dashboard', route: '/dashboard', icon: <IoBarChart /> },
        
        // Customer Management
        { text: 'Customer Registration', route: '/customer-registration', icon: <IoIosPeople /> },
        { text: 'Customer Accounts', route: '/customer-accounts', icon: <FaUserCircle /> },
         // Merchandise & Products
         { text: 'Merchandise Orders', route: '/merchandise-orders', icon: <PiPackageFill /> },
         { text: 'Product Catalog', route: '/product-catalog', icon: <TbPackages /> },
        
        // Water Delivery Operations
        { text: 'Water Inventory', route: '/water-inventory', icon: <PiPackageFill /> },
        { text: 'Delivery Scheduling', route: '/delivery-scheduling', icon: <FaPlaneDeparture /> },
        { text: 'Auto Delivery Setup', route: '/auto-delivery', icon: <TbPackages /> },
        // { text: 'Delivery Routes', route: '/delivery-routes', icon: <FaTruckMoving /> },
        
        // Notifications & Alerts
        { text: 'Threshold Alerts', route: '/threshold-alerts', icon: <AiOutlineFileUnknown /> },
        { text: 'Delivery Notifications', route: '/notifications', icon: <LuPackageCheck /> },
        
       
        
        // Droplets Rewards Program
        { text: 'Droplets Program', route: '/droplets-program', icon: <BiSolidReport /> },
        { text: 'Referral Management', route: '/referrals', icon: <IoIosPeople /> },
        { text: 'Gift Vouchers', route: '/gift-vouchers', icon: <FaUserCircle /> },
        
        // Analytics & Reports
        { text: 'Sales Analytics', route: '/sales-analytics', icon: <BiSolidReport /> },
        // { text: 'Volume Reports', route: '/volume-reports', icon: <IoBarChart /> },
        // { text: 'Financial Reports', route: '/financial-reports', icon: <BiSolidReport /> },
        
        // System Management
        // { text: 'Staff Management', route: '/staff', icon: <GrUserWorker /> },
        { text: 'System Settings', route: '/settings', icon: <GrSettingsOption /> },
        { text: 'Signout', action: handleLogout, icon: <CgLogOut /> },
      ];

  return (
    <div className={`flex ${isMobile ? "fixed z-50" : "relative"} top-0 left-0 ${className || ''}`}>
      {/* Sidebar Overlay for Mobile */}
      {isMobile && open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar Container */}
      <div
        className={`${
          open ? "w-48" : "w-16"
        } bg-gradient-to-br from-blue-700 to-blue-900 text-white shadow-lg min-h-screen flex flex-col transition-all duration-300 overflow-x-auto`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-4">
          <img src={logo} alt="Logo" className="w-40 transition-all bg-white rounded-lg p-2" />
          <button
            onClick={handleDrawerToggle}
            className="text-2xl hover:text-gray-300 p-2"
          >
            {open ? "⟨" : "⟩"}
          </button>
        </div>

        {/* Menu */}
        <ul className="flex flex-col gap-4 px-2 mt-4">
          {menuItems.map(({ text, route, icon, action }, index) => (
            <li key={index}>
              <NavLink
                to={route || "#"}
                onClick={action}
                className={({ isActive }) =>
                  `flex items-center gap-4 px-4 py-3 rounded-lg transition-all duration-300 ${
                    isActive ? "bg-blue-600" : "hover:bg-blue-800"
                  }`
                }
              >
                <span className="text-2xl">{icon}</span>
                {open && <span className="font-medium">{text}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
